import React from 'react';
import PropTypes from 'prop-types';
import TextMapper from '../TextMapper';
import WidgetPagePropTypes from '../../WidgetPage/types';
import css from './text.module.scss';

function Text(props) {
  const { flowId, groupId, toggles, user, app: appState, widgetIndex } = props;

  const app = {
    ...appState,
    ...toggles,
    ...user
  };

  const getGroupField = fieldName => {
    const group = TextMapper[flowId] && TextMapper[flowId][groupId];
    if (!group) return;

    if (widgetIndex === undefined)
      return group[fieldName] && group[fieldName](app);

    return (
      group.widgets &&
      group.widgets[widgetIndex] &&
      group.widgets[widgetIndex][fieldName] &&
      group.widgets[widgetIndex][fieldName](app)
    );
  };

  if (
    getGroupField('header') ||
    getGroupField('subheader') ||
    getGroupField('text')
  ) {
    return (
      <div>
        {getGroupField('image') ? (
          <div className={css.imageWithHeader} data-e2e="image-with-header">
            <div
              className={css.imageWithHeaderText}
              data-e2e="image-with-header-text"
            >
              <h1 data-e2e={`${groupId}-header`}>{getGroupField('header')}</h1>
              <h2 data-e2e={`${groupId}-subheader`}>
                {getGroupField('subheader')}
              </h2>
            </div>
            <div
              data-e2e={`${groupId}-image-container`}
              className={css.imageWithHeaderTextImages}
            >
              <img
                src={`../../static/${getGroupField('image')}`}
                alt="Header Image"
                data-e2e={`${groupId}-header-image`}
              />
            </div>
          </div>
        ) : (
          <>
            <h1 data-e2e={`${groupId}-header`}>{getGroupField('header')}</h1>
            <h2 data-e2e={`${groupId}-subheader`}>
              {getGroupField('subheader')}
            </h2>
          </>
        )}
        <div data-e2e={`${groupId}-info`}>{getGroupField('text')}</div>
      </div>
    );
  }
  return <div />;
}

Text.propTypes = {
  flowId: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  widgetIndex: PropTypes.number,
  app: WidgetPagePropTypes.app
};

export default Text;
